import Component from '../abstracts/Component';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import FixBody from '../utils/FixBody';
import ajaxAction from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';
import PriceRangeComponent from '../components/PriceRangeComponent';
import SaleRangeComponent from '../components/SaleRangeComponent';
import {getFocusElement, hasFocusElement} from '../utils/BrowserHistoryUtils';
import vex from 'vex-js';
import { trapFocusOnModal, removeTrapFocusOnModal } from '../utils/TrapFocus';

export default class FiltersComponent extends Component {
  get SELECTORS() {
    return {
      triggerBtn: '[data-trigger-filters]',
      filtersContainer: '[data-filters-container]',
      listItems: '[data-filters-item]',
      listItemActive: '[data-filters-item].active',
      listItemsLabel: "[data-filters-item-label]",
      liveSubItem: '[data-item-parent-name].live',
      subListPanel: '[data-sublist-container]',
      closeBtn: '[data-trigger-close]',
      closeBtnMobile: '[data-trigger-close-mobile]',
      ctaClear: '[data-cta-clear]',
      ctaView: '[data-cta-view]',
      benefitBar: '[data-benefit-bar]',
      itemText: '[data-item-text]',
      sublistTitle: '[data-sublist-title]',
      sublistText: '[data-sublist-text]',
      productsContainer: '[data-products-container]',
      filtersInputs: '[data-filter-input]',
      filtersInputsNoPrice: '[data-filter-input]:not([name="rangePriceFilter"])',
      priceFilterInputs: 'input[name="rangePriceFilter"]',
      filterSortBy: '[data-filter-sortby]',
      inputs: '.w-f__sublist__item input[type="checkbox"]',
      priceMobileInputs: '[data-mobile-price-filter] input',
      priceMobileContainer: '.w-f__sublist.price-mobile',
      mobileResultsCount: '[data-mobile-results-count]',
      searchResultsCount: '[data-results-count]',
      saleRangeMobileInputs: '[data-mobile-sale-range-filter] input',
      saleRangeMobileContainer: '.w-f__sublist.sale-range-mobile',
      filters: '.w-filters',
      ctaClearNav: '[data-cta-clear-nav]',
      filtersCount: '[data-filters-count]',
      sizeGuideTrigger: '[data-js-size-guide]',
      //sort
      sortTrigger: '[data-trigger-sort]',
      sortContainer: '[data-sort-dropdown]',
      sortRadio: '[data-sort-radio]',
      closeSortMobile: '[data-trigger-close-sort-mobile]',
      seeMoreNumber: '[data-result-number]',
      sortLabel: "[data-sort-label]",
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    // Remove hidden on w-filters when search results are empty
    let queryString = document.location.search;
    let filters = document.querySelectorAll(this.SELECTORS.filters);
    if (queryString.indexOf('isRefineSearch') !== -1 && $(filters).hasClass('hidden')) {
      $(filters).removeClass('hidden');
    }
    this.listItems = this.$component.querySelectorAll(this.SELECTORS.listItems);
    this.subListPanel = this.$component.querySelector(
      this.SELECTORS.subListPanel
    );
    this.triggerBtn = this.$component.querySelector(
      this.SELECTORS.triggerBtn
    );
    this.sortTrigger = this.$component.querySelector(
      this.SELECTORS.sortTrigger
    );
    //this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.closeBtnMobile = this.$component.querySelector(
      this.SELECTORS.closeBtnMobile
    );
    this.filtersContainer = document.querySelector(
      this.SELECTORS.filtersContainer
    );
    this.sortContainer = this.$component.querySelector(
      this.SELECTORS.sortContainer
    );
    this.closeSortMobile = this.$component.querySelector(
      this.SELECTORS.closeSortMobile
    );
    this.seeMoreNumber = document.querySelector(this.SELECTORS.seeMoreNumber);
    this.sortRadios = this.$component.querySelectorAll(this.SELECTORS.sortRadio);
    this.sortLabels = this.$component.querySelectorAll(
      this.SELECTORS.sortLabel,
    );
    this.ctaClear = this.$component.querySelector(this.SELECTORS.ctaClear);
    this.ctaView = this.$component.querySelector(this.SELECTORS.ctaView);
    this.closeFilters = this.closeFilters.bind(this);

    this.filtersInputs = document.querySelectorAll(this.SELECTORS.filtersInputs);
    this.filtersInputsNoPrice = document.querySelectorAll(this.SELECTORS.filtersInputsNoPrice);
    this.filterSortBy = document.querySelector(this.SELECTORS.filterSortBy);
    this.productsContainer = document.querySelector(this.SELECTORS.productsContainer);
    this.qs = document.querySelector('.search__input-container [data-search-input]') || document.querySelector('[data-search-input]');
    this.mobileResultsCount = document.querySelector(this.SELECTORS.mobileResultsCount);
    this.priceMobileContainer = document.querySelector(this.SELECTORS.priceMobileContainer);
    this.ctaClearNav = document.querySelector(this.SELECTORS.ctaClearNav);
    this.filtersCounts = document.querySelectorAll(this.SELECTORS.filtersCount);
    this.sizeGuideTrigger = this.$component.querySelectorAll(this.SELECTORS.sizeGuideTrigger);
    // extra components
    this.trackingComponent = new TrackingComponent();
    this.PriceRangeComponent = new PriceRangeComponent(htmlEl);
    this.SaleRangeComponent = new SaleRangeComponent(htmlEl);
    this.ajaxAction = new ajaxAction();

    this.activeEventListeners = new Map();
    this.isProcessingSortRequest = false;
  }

  bindEvents() {
    let scrollY = 0;

    //check if
    this.triggerBtn.addEventListener('click', () => {
      this.manageFiltersLayer();
    });

    this.ctaClear.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.resetFilters();
    });

    this.ctaClearNav.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.resetFilters();
    });

    this.ctaView.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeFilters(scrollY);
      this.applyFilters();
    });

    //check item label

    const labels = document.querySelectorAll("[data-filters-item-label]");

    labels.forEach((label) => {
      const toggleCheckbox = () => {
        const inputId = label.getAttribute("for");
        const input = document.getElementById(inputId);
        if (input && input.type === "checkbox" && !input.disabled) {
          input.checked = !input.checked;
        }
      };
      // mouse click
      label.addEventListener("click", (e) => {
        e.preventDefault();
        toggleCheckbox();
      });
      // keyboard enter
      label.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          toggleCheckbox();
        }
      });
    });
    //end check item label

    /*this.closeBtn.addEventListener('click', () => {
      this.closeFilters(scrollY);
    });*/

    this.closeBtnMobile.addEventListener('click', () => {
      this.closeFilters(scrollY);
    });

    this.closeSortMobile.addEventListener('click', () => {
      this.manageSortLayer();
    });

    this.handleSubnavRender();
    this.handleMenuItemClick();
    this.bindSalesLabel();
    this.bindMobilePrices();
    this.bindSorting();
    // this.bindMobileSaleRanges();
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // check if filters are available after filtering
      this.refreshFilters(payload.response);
      if (document.body.classList.contains('t-search') || document.body.classList.contains('t-category')) {
        this.updateSearchResultsCount(payload.response);
      }
      if (isMobile(MobileBreakpoint.Max1023)) {
        this.refreshMobilePrices(payload.response);
        //updates mobile results count
        this.updateMobileResultsCount(payload.response);
      }
      let newQs = payload.query.replace(this.QUERY_PARAMS.base() + '&', '?');
      history.replaceState(null, null, newQs);
      this.updateFilterNav(payload.res);
      //update result counter in VIEW MORE button
      if(payload.response.querySelector(this.SELECTORS.seeMoreNumber)){
        this.seeMoreNumber.innerHTML = payload.response.querySelector(this.SELECTORS.seeMoreNumber).innerHTML;
      }
    });

    // dom ready
    $(document).ready(() => {
      let $focusElement = $(getFocusElement());
      let handleFocus = hasFocusElement() && $focusElement.length > 0;
      if (handleFocus) {
        this.timedOutScrollToElement($focusElement);
      }

      this.updateFilterNav();
    });

    //size guide popup
    this.handleSizeGuide();
  }

  timedOutScrollToElement($element) {
    setTimeout(() => {
      this.scrollToElement($element);
    }, 500);
  }

  scrollToElement($element) {
    $element.get(0).scrollIntoView({block: 'center', inline: 'nearest', behavior: 'smooth'});
  }

  closeFilters(scrollY) {
    this.filtersContainer.classList.remove('open');
    this.$component.classList.remove('open');
    if (isMobile(MobileBreakpoint.Max1023)) {
      FixBody.unblock(scrollY);
    }
    if (window.matchMedia('(max-width: 1024px)').matches) {
      this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
    }
  }

  updateFilterNav(res = false) {
    // update filters counter desktop
    this.manageFiltersCounter();
    // hide/show reset button
    this.manageResetButton();
    // update checked sort
    this.manageSortSelection();

    if (res) {
      // update sort layer and mobile results count
      this.ajaxAction.renderContent(res, 'mobile-results-count');
    }

    this.bindSortSelection();
  }

  bindSorting() {
    // Cleanup dei listener esistenti
    this.cleanupEventListeners('sort');

    // Layer close handler
    const outsideClickHandler = (e) => {
      if (!isMobile(MobileBreakpoint.Max1023) &&
        e.target !== this.sortTrigger &&
        !this.sortTrigger.contains(e.target) &&
        this.sortContainer.classList.contains("open")) {
        this.manageSortLayer();
      }
    };

    this.registerEventListener('sort', document, 'click', outsideClickHandler);

    // Sort trigger handler
    const triggerClickHandler = () => {
      this.manageSortLayer();
    };

    this.registerEventListener('sort', this.sortTrigger, 'click', triggerClickHandler);

    // UNIQUE HANDLER FOR SORTING – Removes duplication
    this.bindSortSelection();
  }

  bindSortSelection() {
    const filterSortBy = this.filterSortBy;
    const sortTrigger = this.sortTrigger;

    const handleSortSelection = async (sortValue, trackingElement = null) => {
      if (this.isProcessingSortRequest) return;

      this.isProcessingSortRequest = true;
      try {
        if (!sortValue || sortValue === "undefined") return;

        filterSortBy.value = sortValue;
        sortTrigger.dataset.currentSort = sortValue;

        if (trackingElement) {
          this.trackingComponent.actions.filterTracking(trackingElement, true);
        }

        this.manageSortLayer();
        await this.applyFilters();
      } catch (error) {
        console.error("Error in sort selection:", error);
      } finally {
        setTimeout(() => {
          this.isProcessingSortRequest = false;
        }, 300);
      }
    };

    // Recalculate references (important after AJAX)
    this.sortRadios = this.sortContainer.querySelectorAll(this.SELECTORS.sortRadio);
    this.sortLabels = this.sortContainer.querySelectorAll(this.SELECTORS.sortLabel);

    // Listener on the radio
    this.sortRadios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        handleSortSelection(e.target.value, e.target);
      });
    });

    // Listener on label
    this.sortLabels.forEach((label) => {
      label.addEventListener("click", (e) => {
        e.preventDefault();
        const inputId = label.getAttribute("for");
        const radio = document.getElementById(inputId);
        if (radio) {
          radio.checked = true;
          handleSortSelection(radio.value, radio);
        }
      });
      label.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          const inputId = label.getAttribute("for");
          const radio = document.getElementById(inputId);
          if (radio) {
            radio.checked = true;
            handleSortSelection(radio.value, radio);
          }
        }
      });
    });
  }

  handleMenuItemClick() {
    const listItems = document.querySelectorAll(this.SELECTORS.listItems);
    this.cleanActiveMobileFilters();

    const activeItem = (itemIndex, {avoidMobile = false} = {}) => {
      this.cleanActiveMobileFilters();
      listItems.item(itemIndex).classList.add('active');
      this.$emit(this.$customEvents.FILTERS_EVENTS.active, avoidMobile);
    };

    listItems.forEach((listItem, index) => {
      listItem.addEventListener('click', e => {
        if (!e.target.classList.contains('active')) {
          activeItem(index);
        }
      });
    });
  }

  cleanActiveMobileFilters() {
    document.querySelectorAll(this.SELECTORS.listItems).forEach(menuItem => {
      menuItem.classList.remove('active');
    });
  }

  cleanupEventListeners(elementType) {
    if (this.activeEventListeners.has(elementType)) {
      const listeners = this.activeEventListeners.get(elementType);
      listeners.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });
      this.activeEventListeners.delete(elementType);
    }
  }

  registerEventListener(elementType, element, event, handler) {
    if (!this.activeEventListeners.has(elementType)) {
      this.activeEventListeners.set(elementType, []);
    }

    element.addEventListener(event, handler);
    this.activeEventListeners.get(elementType).push({
      element,
      event,
      handler
    });
  }

  handleSubnavRender() {
    this.$on(
      this.$customEvents.FILTERS_EVENTS.active,
      ({payload: avoidMobile = false}) => {
        const activeItem = document.querySelector(
          this.SELECTORS.listItemActive
        );
        const sublistSelector = `[data-item-parent-name=${
          activeItem.dataset.filtersItem
        }]`;
        const sublistItems = document.querySelector(sublistSelector);
        this.elementEnter(
          sublistItems,
          document.querySelector(this.SELECTORS.liveSubItem)
        );
        if (!avoidMobile && isMobile(MobileBreakpoint.Max1023)) {
          const title = activeItem.querySelector(this.SELECTORS.itemText).innerHTML;
          this.setMobilePanel(title, activeItem.dataset.filtersItem);
        }
      }
    );
  }

  elementEnter(
  elementEnter,
  elementExit,
  {destroy = false, goingOutEffect = 'goingOut'} = {}
  ) {
    /**
     * Hide old menu
     */
    if (elementExit && elementExit.classList) {
      elementExit.classList.remove('live');
      elementExit.classList.add(goingOutEffect);
      setTimeout(() => {
        elementExit.classList.remove(goingOutEffect);
        if (destroy) {
          elementExit.remove();
        }
      }, 500);
    }

    /**
     * Show new menu
     */
    elementEnter.classList.add('live');
  }

  setMobilePanel(title, code) {
    const subListPanel = document.querySelector(
      this.SELECTORS.subListPanel
    );
    subListPanel.classList.add('open');
    subListPanel.querySelector(
      this.SELECTORS.sublistText
    ).innerHTML = title;
    if(this.sizeGuideTrigger && this.sizeGuideTrigger.length > 1) {
      if(code === 'sizeFilter') {
        this.sizeGuideTrigger[1].classList.remove('hidden');
      } else {
        this.sizeGuideTrigger[1].classList.add('hidden');
      }
    }
    subListPanel
      .querySelector(this.SELECTORS.sublistTitle)
      .addEventListener('click', () => {
      subListPanel.classList.remove('open');
      this.cleanActiveMobileFilters();
    });
  }

  //END WIP

  get QUERY_PARAMS() {
    return {
      base: () => {
        if (document.body.classList.contains('t-search')) {
          return '?partial=true&save=false';
        }
        return '?save=false';
      },
      pagination: (page) => {
        let paginationQueryBit = '';
        if (page) {
          // currentPage
          paginationQueryBit = '&page=' + page;
        }
        // if not cached
        return paginationQueryBit;
      },
      textSearch: () => {
        // on search page
        if (document.body.classList.contains('t-search')) {
          // other catches
          if (typeof this.qs == 'undefined' || this.qs == null) return;
          if (typeof this.qs.getAttribute('value') != null) {
            let q = this.qs.getAttribute('value');
            let matchString = new RegExp('[^:]*', '');
            let search = q.match(matchString);
            return search[0];
          }
        }
        return '';
      },
      sortBy: (qs = false) => {
        // if there is no sort, exit
        if (typeof this.filterSortBy == 'undefined' || this.filterSortBy == null) return;
        let sort = this.filterSortBy.value;

        // return the sort
        if(qs) {
          return '&sort=' + sort + ':';
        } else {
          return ':'+sort;
        }
      },
      priceRange: (isReset) => {
        let priceQuery = this.PriceRangeComponent.buildQuery(isReset);
        return priceQuery;
      },
      saleRange: () => {
        let saleRangeQuery = this.SaleRangeComponent.buildQuery();
        return saleRangeQuery;
      },
      formData: () => {
        // query
        let filterQuery = '';
        let isSales = false;
        // form inputs
        document.querySelectorAll(this.SELECTORS.filtersInputsNoPrice).forEach(input => {
          if (input.checked) {
            if (input.id.indexOf('inSales') !== -1) {
              isSales = true;
              //tracking
              this.trackingComponent.actions.filterTracking(input.name, input.value);
            }
            filterQuery = filterQuery + ':' + input.name + ':' + input.value;
            //tracking
            this.trackingComponent.actions.filterTracking(input.name, input.value);
            if (isSales == false) {
              filterQuery.replace('inSales:true:', '');
            }
          }
        });
        return filterQuery;
      }
    }
  }

  // build the filters
  buildQuery(page = false, isReset) {
    // get full query
    let fullQuery =
    this.QUERY_PARAMS.base() +
    '&isRefineSearch=' +
    this.hasActiveFilters() + '&q=' +
    this.QUERY_PARAMS.textSearch() +
    this.QUERY_PARAMS.sortBy() +
    this.QUERY_PARAMS.priceRange(isReset) +
    this.QUERY_PARAMS.saleRange() +
    this.QUERY_PARAMS.formData() +
    this.QUERY_PARAMS.pagination(page);

    this.log('fullQuery ', fullQuery);
    return fullQuery;
  }

  // filter function
  filterQuery(page, query = '', isReset = false) {
    this.log('launch query');
    // build the query
    if (query === '') {
      query = this.buildQuery(page, isReset);
    }
    // main products container
    let productsContainer = this.productsContainer;
    // get the page
    this.getFilteredPage(query).then(res => {
      // render the page
      this.renderPage(res, productsContainer, query, isReset);
      // is priceFilter present
      if (document.querySelector('.noUi-handle-lower') != null
      && document.querySelector('#currentSliderMinValue') != null) {
        // read current min, max value
        let currentMinValue = document.querySelector('.noUi-handle-lower').ariaValueNow;
        let currentMaxValue = document.querySelector('.noUi-handle-upper').ariaValueNow;
        // set values in tag
        document.querySelector('#currentSliderMinValue').innerHTML = parseInt(currentMinValue);
        document.querySelector('#currentSliderMaxValue').innerHTML = parseInt(currentMaxValue);
      }
    });
  }

  // get page via ajax function
  getFilteredPage(query) {
    // get content
    return this.ajaxAction.getPage(query);
  }

  // render results
  renderPage(res, target, query = false, isReset = false) {
    // html response
    let response = new DOMParser().parseFromString(res, 'text/html');
    // render content
    try {
      this.ajaxAction.renderContent(res, 'products');
    } catch (e) {
      console.warn('Error products render content:', e);
    }
    if (isReset) {
      this.ajaxAction.renderContent(res, 'filters-list');
      this.ajaxAction.renderContent(res, 'filters-sublist');
      this.ajaxAction.renderContent(res, 'product-count');
      // hide remove filters buttons
      this.hideFilteredElements();
      let newRanger = document.querySelector(this.PriceRangeComponent.SELECTORS.rangerBar);
      // is priceFilter present
      try {
        const sliderExists = this.PriceRangeComponent.rangeSlider?.noUiSlider;
        if (newRanger && sliderExists) {
          const newSliderLogic = new PriceRangeComponent(newRanger);
          newSliderLogic.renderNewSlider();
        }
      } catch (e) {
        console.warn(e);
      }
      this.handleMenuItemClick();
      this.subListPanel = this.$component.querySelector(
        this.SELECTORS.subListPanel
      );
      if (this.subListPanel) {
        this.subListPanel.classList.remove('open');
      }
      this.filtersCounts = document.querySelectorAll(this.SELECTORS.filtersCount);
      this.filtersInputs = document.querySelectorAll(this.SELECTORS.filtersInputs);
    }


    // emit events
    if(query) {
      this.$emit(this.$customEvents.FILTERS_EVENTS.pageLoaded);
      this.$emit(this.$customEvents.FILTERS_EVENTS.updated, {response: response, res: res, query: query});
    }

    // scroll to top
    window.scrollTo(0, 0); //emette al caricamento di pagina
  }

  // apply function
  applyFilters(isReset = false) {
    // creates and launches query
    this.filterQuery(false, '', isReset);
  }

  // reset function
  resetFilters() {
    // cycle desktop inputs
    document.querySelectorAll(this.SELECTORS.inputs).forEach(input => {
      // set input false
      if (input.checked === true) {
        input.checked = false;
      }
    });
    // cycle mobile inputs
    document.querySelectorAll(this.SELECTORS.priceMobileInputs).forEach(input => {
      // set input false
      if (input.checked === true) {
        input.checked = false;
      }
    });
    // reset sliders
    this.PriceRangeComponent.resetSlider();
    // launch void query
    this.filterQuery(false, '', true);
  }

  hasActiveFilters(getFiltersCount = false) {
    let isAnyActive = false;
    let activeFiltersCount = 0;

    document.querySelectorAll(this.SELECTORS.filtersInputs).forEach(input => {
      if (input.checked) {
        isAnyActive = true;
        activeFiltersCount++;
      }
    });

    // check price for desktop, needs query on document to find slider values
    if (this.PriceRangeComponent.isSliderChanged(document.querySelector(this.PriceRangeComponent.SELECTORS.rangeSlider))) {
      isAnyActive = true;
      activeFiltersCount++;
    }

    if (getFiltersCount && activeFiltersCount > 0) {
      return activeFiltersCount;
    }

    return isAnyActive;
  }

  manageFiltersCounter() {
    try {
      this.filtersCounts.forEach((count) => {
        if (count != null) {
          if (this.hasActiveFilters()) {
            count.innerHTML = " (" + this.hasActiveFilters(true) + ")";
          } else {
            count.innerHTML = "";  //removes counter besides filter button
          }
        }
      });
    } catch (e) {
      console.warn("Filters counter failed to render.");
    }
  }

  manageResetButton() {
    // Remove hidden on w-filters when search results are empty
    let queryString = document.location.search;
    const params = new URLSearchParams(queryString);
    if(this.ctaClearNav){
      try {
        if (params.get("isRefineSearch") === "true" && window.matchMedia('(min-width:768px)').matches) {
          //show
          this.ctaClearNav.classList.remove("hidden");
          this.ctaClearNav.classList.add("show");
        } else {
          //hide
          this.ctaClearNav.classList.add("hidden");
          this.ctaClearNav.classList.remove("show");
        }
      } catch (e) {
        console.warn("Reset button failed to render");
      }
    }
  }

  hideFilteredElements() {
    //hide
    this.ctaClearNav.classList.add("hidden");
    this.ctaClearNav.classList.remove("show");

    const activeFilters = this.triggerBtn.querySelector('.active-filters');
    if (activeFilters !== null) {
      activeFilters.innerHTML = "";
    }
  }

  refreshFilters(response) {
    document.querySelectorAll(this.SELECTORS.filtersInputsNoPrice).forEach(input => {
      if (
      input.id === 'inSalesFilterMobile' ||
      input.id === 'newArrivalFilterMobile' ||
      input.id === 'inSales' ||
      input.id === 'newArrival'
      ) {
        return;
      }
      if (response.querySelector('#' + CSS.escape(input.id)) == null && !input.checked) {
        input.parentElement.classList.add('unavailable');
        input.disabled = true;
      } else {
        input.parentElement.classList.remove('unavailable');
        input.disabled = false;
      }
    });
    this.filtersCounts = document.querySelectorAll(this.SELECTORS.filtersCount);
    this.filtersInputs = document.querySelectorAll(this.SELECTORS.filtersInputs);
    this.bindSalesLabel();
  }

  setMobilePrices(input) {
    if (input.checked) {
      let range = input.dataset.value.split("|");
      document.querySelector('.w-price-range [data-input-min]').value = range[0];
      if (range[1] !== '') {
        document.querySelector('.w-price-range [data-input-max]').value = range[1];
      }
    } else {
      document.querySelector('.w-price-range [data-input-min]').value = '';
      document.querySelector('.w-price-range [data-input-max]').value = '';
    }
  }

  // clear the mobile prices given the selected one
  cleanOtherMobilePrices(selectedInput) {
    document.querySelectorAll(this.SELECTORS.priceMobileInputs).forEach(input => {
      if (input.id !== selectedInput.id) {
        input.checked = false;
      }
    });
    if (document.querySelector('.insales-filter')) {
      this.refreshSalesFilterMobile();
    }
  }

  // refresh the mobile prices on update filters event
  refreshMobilePrices(response) {
    if (response.querySelector(this.SELECTORS.priceMobileContainer) != null) {
      let newPriceRanges = response.querySelector(this.SELECTORS.priceMobileContainer).innerHTML;
      if (this.priceMobileContainer.innerHTML !== newPriceRanges) {
        this.priceMobileContainer.innerHTML = newPriceRanges;
        this.bindMobilePrices();
        if (document.querySelector('.insales-filter')) {
          this.refreshSalesFilterMobile(true);
        }
      }
    }
  }

  // update mobile products counter
  updateMobileResultsCount(response) {
    if (response.querySelector(this.SELECTORS.searchResultsCount) != null) {
      // new count from the ajax response
      let newCount = response.querySelector(this.SELECTORS.mobileResultsCount).innerHTML;
      // insert count in mobile layer
      this.mobileResultsCount.innerHTML = newCount;
    }
  }

  // bind the mobile click to the desktop filter
  bindMobilePrices() {
    document.querySelectorAll(this.SELECTORS.priceMobileInputs).forEach(input => {
      input.addEventListener('click', () => {
        if (input.id === 'inSalesFilterMobile') {
          const salesFilter = document.querySelector('.insales-filter');
          if (salesFilter) {
            salesFilter.checked = input.checked;
          }
          this.refreshSalesFilterMobile();
        } else if (input.id === 'newArrivalFilterMobile') {
          const newArrivalFilter = document.querySelector('.newarrival-filter');
          if (newArrivalFilter) {
            newArrivalFilter.checked = input.checked;
          }
        } else if (input.dataset.value) {
          this.setMobilePrices(input);
          this.cleanOtherMobilePrices(input);
        }
      });
    });
  }
  manageFiltersLayer() {
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    if (this.filtersContainer.classList.contains('open')) {
      this.closeFilters(scrollY);
    } else {
      this.filtersContainer.classList.add('open');
      this.$component.classList.add('open');
      if (isMobile(MobileBreakpoint.Max1023)) {
        scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
        FixBody.block(barHeight);
      }
    }
    if (window.matchMedia('(max-width: 1024px)').matches) {
      this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
    }
  }

  manageSortLayer() {
    // toggles filter layer
    const isLayerOpen = this.sortContainer.classList.contains("open");

    // mobile logic
    if (isMobile(MobileBreakpoint.Max1023)) {
      if (isLayerOpen) {
        FixBody.unblock(scrollY);
      } else {
        let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
        let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
        scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
        FixBody.block(barHeight);
      }
    }

    if (isLayerOpen) {
      this.sortContainer.classList.remove("open");
      this.sortLabels.forEach((label) => {
        label.tabIndex = -1;
      });
      if (window.matchMedia('(max-width: 1024px)').matches) {
        this.$emit(this.$customEvents.POPUP_EVENTS.resumeTimer);
      }
    } else {
      this.sortContainer.classList.add("open");
      this.sortLabels.forEach((label) => {
        label.tabIndex = 0;
      });
      if (this.filtersContainer.classList.contains('open')) {
        this.closeFilters(scrollY);
      }
      if (window.matchMedia('(max-width: 1024px)').matches) {
        this.$emit(this.$customEvents.POPUP_EVENTS.pauseTimer);
      }
    }
  }

  manageSortSelection() {
    const currentSort = this.sortTrigger.dataset.currentSort;

    // Update the radio button state
    this.sortRadios.forEach((radio) => {
      radio.checked = (radio.value === currentSort);
    });

    // Manage tabIndex for accessibility
    const isOpen = this.sortContainer.classList.contains("open");
    this.sortLabels.forEach((label) => {
      label.tabIndex = isOpen ? 0 : -1;
    });
  }

  // refresh the sale filter mobile trigger
  refreshSalesFilterMobile(isResponse) {
    let mobileSalesFilter = document.querySelector('#inSalesFilterMobile');
    let mainSalesFilter = document.querySelector('.insales-filter');
    if (mobileSalesFilter != null && mainSalesFilter != null) {
      if (isResponse) {
        mobileSalesFilter.checked = !!mainSalesFilter.checked;
      } else {
        mainSalesFilter.checked = !!mobileSalesFilter.checked;
      }
    }
  }

  // sales label in mobile
  bindSalesLabel() {
    if (document.querySelector('.sales-label') != null) {
      document.querySelector('.sales-label').addEventListener('click', () => {
        let salesInput = document.querySelector('.insales-filter');
        if (salesInput) {
          salesInput.checked = !salesInput.checked;
        }
      });
    }
  }

  // update products counter
  updateSearchResultsCount(response) {
    const respSearchResultsCount = response.querySelector(this.SELECTORS.searchResultsCount);
    const pageSearchResultsCount = document.querySelector(this.SELECTORS.searchResultsCount);

    if (respSearchResultsCount != null && pageSearchResultsCount != null) {
      pageSearchResultsCount.innerHTML = respSearchResultsCount.innerHTML;
    }
  }

  ////////////////////////////
  //  // sale range mobile filter
  //  // bind the mobile click to the desktop filter
  //  bindMobileSaleRanges() {
  //    document.querySelectorAll(this.SELECTORS.saleRangeMobileInputs).forEach(input => {
  //      input.addEventListener('click', () => {
  //        // sets sale range in sale range slider for main logic
  //        this.setSaleRangeFromMobile(input);
  //        // only one sale range can be active
  //        this.cleanSaleRangeInputs(input);
  //      });
  //    });
  //  }
  //  // set values on desktop sale range slider
  //  setSaleRangeFromMobile(input) {
  //    if(input.checked) {
  //      let range = input.dataset.value.split("|");
  //      // set min val
  //      document.querySelector('.w-sale-range [data-input-min]').value = range[0];
  //      if(range[1] != '') {
  //        // set max val
  //        document.querySelector('.w-sale-range [data-input-max]').value = range[1];
  //      }
  //    } else {
  //      // reset values
  //      document.querySelector('.w-sale-range [data-input-min]').value = '';
  //      document.querySelector('.w-sale-range [data-input-max]').value = '';
  //    }
  //  }
  //
  //  // clear the mobile prices given the selected one
  //  cleanSaleRangeInputs(selectedInput) {
  //    document.querySelectorAll(this.SELECTORS.saleRangeMobileInputs).forEach(input => {
  //      if(input.id !== selectedInput.id) {
  //        input.checked = false;
  //      }
  //    });
  //  }

  // handle size guide open //
  handleSizeGuide() {
    const ctx = this;
    if (this.sizeGuideTrigger) {
      this.sizeGuideTrigger.forEach(trigger => {
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          trigger.setAttribute('disabled', '');
          fetch(trigger.href)
            .then(response => response.text())
            .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");
            const sizeGuide = doc.querySelector('[data-ajax-chunk]');
            vex.open({
              unsafeContent: sizeGuide,
              closeClassName: 'icon close --pointer',
              className: '--editorial size-guide-layer',
              showCloseButton: true,
              afterOpen: function () {
                this.closeEl.classList.remove('vex-close');
                // Make close button accessible
                ctx.makeCloseButtonAccessible(this.closeEl, sizeGuide);
                // Trap focus within the modal for accessibility
                this.trapFocusHandler = trapFocusOnModal(this.contentEl);
                import('./CollapseComponent')
                  .then(({default: module}) => {
                  const component = new module(sizeGuide);
                  component.render();
                })
                  .catch(error => {
                  console.error("Failed to load the component", error.stack);
                });
              },
              afterClose: function () {
                // Remove trap focus event listener
                if (this.trapFocusHandler) {
                  removeTrapFocusOnModal(this.contentEl, this.trapFocusHandler);
                }
                trigger.removeAttribute('disabled');
                trigger.focus();
              }
            });
          })
            .catch(error => console.error(error));
        });
      });
    }
  }

  // Make close button accessible by converting to proper button element
  makeCloseButtonAccessible(closeElement, sizeGuideContent) {
    if (closeElement && closeElement.tagName !== 'BUTTON') {
      // Get translated close button label from the content
      const closeButtonText = sizeGuideContent?.dataset?.closeButton;

      // Create a proper button element
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = closeElement.className;
      closeButton.setAttribute('aria-label', `${closeButtonText}`);
      closeButton.innerHTML = closeElement.innerHTML;

      // Copy the click event
      closeButton.addEventListener('click', () => {
        closeElement.click();
      });

      // Replace the original element
      closeElement.parentNode.replaceChild(closeButton, closeElement);
    }
  }

  render() {
    this.activeEventListeners.forEach((listeners, elementType) => {
      this.cleanupEventListeners(elementType);
    });
    super.render();
    this.bindEvents();
  }

}
